export default __webpack_public_path__ + "static/media/CAF.6cd4ee99.svg";